<template>
  <div class="w-full">
    <toggle-switch
      :id="`${day.name}-active-toggle`"
      :name="`${day.name}-active-toggle`"
      class="text-black"
      :value="day.active"
      :sync="true"
      validate="required"
      :qaid="`${day.name}-store-hours.toggle`"
      :text-label="day.name"
      @change="toggleDay"
    />

    <!-- If the toggle is on -->
    <el-collapse-transition>
      <div v-if="day.active">
        <!-- Hour Range Datepickers -->
        <transition-group name="flip-ranges" tag="div">
          <div v-for="(range, index) in day.ranges" :key="range.id" class="day__range flex items-center mb-1">
            <store-hour-range :index="index" :day="day" :range="range" @update:remove="removeRange(index)" />
          </div>
        </transition-group>

        <!-- Add New Range -->
        <trek-button v-if="canAddRange" text small icon="add" class="mt-2" @click.prevent="addRange">
          <span v-html="addRangeText"></span>
        </trek-button>
      </div>
    </el-collapse-transition>
    <hr class="rule" />
  </div>
</template>

<script>
import has from 'lodash/has';
import ToggleSwitch from '@/components/ToggleSwitch';
import ElCollapseTransition from '@/transitions/collapse-transition';
import StoreHourRange from '@/components/containers/my-company/StoreHourRange';
import TrekButton from '@/components/TrekButton';

export default {
  name: 'StoreDay',
  components: {ToggleSwitch, ElCollapseTransition, StoreHourRange, TrekButton},
  props: {
    day: {
      type: Object,
      default: () => {},
    },
    addRangeText: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      value: this.day.active,
    };
  },

  computed: {
    canAddRange() {
      return this.day.ranges.length < 2;
    },
  },
  methods: {
    toggleDay({value}) {
      this.day.active = value;
      if (this.day.name && this.day.ranges && !has(this, 'day.ranges[0].dayName')) {
        this.$set(this.day, 'ranges[0].dayName', this.day.name);
      }
    },

    addRange() {
      this.day.ranges.push({
        id: this.day.ranges.length,
        dayName: this.day.name,
        startTime: '8:00 AM',
        endTime: '5:00 PM',
      });
    },

    removeRange(index) {
      return this.day.ranges.splice(index, 1);
    },
  },
};
</script>
